import axios from "axios";
import { Country } from "../types/common";
import { toInternationalPhoneNumber } from "../utils/validation";
import { getAndCacheToken } from "./service.helper";

interface CallApplicantProps {
  to: string;
  country?: Country;
}

const initItxAPI = async () => {
  try {
    let itxAPI;
    const { data } = await axios("/api/v2/secrets");

    if (data) {
      const endpoint = await data.itxEndpoint;
      itxAPI = axios.create({
        baseURL: `${endpoint}/rest/itxdialer`,
        withCredentials: true,
        timeout: 10000,
        headers: {
          "Content-Type": "application/json"
        }
      });
    }
    return itxAPI;
  } catch (error) {
    console.error("Error initializing Axios:", error);
    return null;
  }
};

export const callApplicant = async ({
  to,
  country = Country.ES
}: CallApplicantProps) => {
  const itxAPI: any = await getAndCacheToken("itxAccessToken", initItxAPI);
  to = toInternationalPhoneNumber(to, country);

  await itxAPI.get(`/externalcall?callNumber=${to}`);
};
